import React, { useEffect, useState } from 'react';
import './Button.scss';
import { getWelcomePage } from '../services/session.service';
import LoadingSpinner from './LoadingSpinner';
import PageEditor from './PageEditor';

type SessionWelcomePageEditorProps = {
  sessionReference: string;
  setMessage: (message: string) => void;
  setErrors: (errors: string[]) => void;
};

interface LoadingState {
  welcomeDelete: boolean;
  iconDelete: boolean;
  iconToggle: boolean;
}

const SessionWelcomePageEditor: React.FC<SessionWelcomePageEditorProps> = ({
  sessionReference,
  setMessage,
  setErrors
}) => {
  const [loading, setLoading] = useState(true);

  const [pageId, setPageId] = useState<string | null>(null);

  const getWelcomeData = async () => {
    setLoading(true);

    try {
      const result = await getWelcomePage(sessionReference);

      if (result.success && result.data) {
        setPageId(result.data.pageId);
      } else {
        setErrors(result.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWelcomeData();
  }, []);

  if (loading) {
    return <LoadingSpinner inline={true} />;
  }

  return (
    <>
      <h2>About screen</h2>
      <p>
        This content will be shown to the user when they click the
        &apos;About&apos; button
      </p>
      {pageId && (
        <PageEditor
          pageReference={pageId}
          setMessage={(p) => setMessage(p)}
          setErrors={(p) => setErrors(p)}
        />
      )}
    </>
  );
};

export default SessionWelcomePageEditor;
